var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 0.6H8.59961V9.65527V9.86878L8.76363 9.7321L11.6176 7.3538L12.734 8.28418L7.79961 12.3962L2.86519 8.28418L3.98164 7.3538L6.83559 9.7321L6.99961 9.86878V9.65527V0.6ZM14.8996 15.4H0.699609V14.1H14.8996V15.4Z",
    fill: "#B4B1B1",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconGray);
export default __webpack_public_path__ + "static/media/downloadIconGray.4cbb90e1f5052d1dad8f06707d59a849.svg";
export { ForwardRef as ReactComponent };